import './FeatureProperties.scss';
import { Loader, PropertyCard } from '../../../../components';
// import { propertyCards } from '../../../../shared/dataCards';
import { ArrowIcon } from '../../../../assets/icons';
import { useRef } from 'react';
import { useCollection } from '../../../../hooks';

const FeatureProperties = () => {
  const { documents, error } = useCollection('featureProperties', undefined, [
    'createdAt',
    'desc',
  ]);
  const refCont = useRef(null);

  const scroll = (scrollOffset) => {
    refCont.current.scrollLeft += scrollOffset;
  };

  return (
    <div className="feature-properties">
      <div className="feature-properties--top">
        <h4 className="subtitle">Feature Properties</h4>
        {error && <p className="error">{error}</p>}
        <div className="btns-container">
          <button className="arrow-btn left" onClick={() => scroll(-150)}>
            <ArrowIcon />
          </button>
          <button className="arrow-btn right" onClick={() => scroll(150)}>
            <ArrowIcon />
          </button>
        </div>
      </div>

      <div className="feature-properties--bottom" ref={refCont}>
        {documents ? (
          documents.map((property) => (
            <PropertyCard
              key={property.id}
              id={property.url}
              name={property.name}
              cardPicURL={property.cardPicURL}
              location={property.location}
              unit={property.unitType[0]}
              currency={property.currency}
            />
          ))
        ) : (
          <div className="loader-container">
            <Loader />
          </div>
        )}
      </div>

      <p className="quote">
        “ The journey of a thousand miles begins with a single step ”
      </p>
    </div>
  );
};

export default FeatureProperties;
